import { useBrandVisualKit } from 'hooks/queries/workspaces/useBrandVisualKit'
import Styles from './ColorsPanel.module.scss'
import { Section } from './Section'
import { ColorSwatch } from '../ColorSwatch/ColorSwatch'
import { isEqual } from 'lodash'
import { Text } from 'blaze-ui/Text/Text'
import { Color } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { useBrandVisualKits } from 'hooks/queries/workspaces/useBrandVisualKits'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { ChevronDown } from 'blaze-ui/icons'
import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import { Key } from 'react'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { Button } from 'blaze-ui/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface BrandColorsProps {
  id: number
  selectedColor?: Color
  onSelect: (color: Color) => void
}

export const BrandColors = observer(({ id, selectedColor, onSelect }: BrandColorsProps) => {
  const { designStore } = useRootStore()
  const { data } = useBrandVisualKit({ id })
  const { isMobile } = useResponsiveDesign()
  const brandVisualKitsQuery = useBrandVisualKits()
  const brandKit = data?.brand_visual_kit
  const brandVisualKits = brandVisualKitsQuery.data?.brand_visual_kits
  const brandColors = brandKit?.primary_color_palette.colors

  if (!brandKit || !brandColors?.length || !brandVisualKits) return null

  const colors: Color[] = brandColors.map((color) => ({ type: 'solidColor', color: color.hex, opacity: 1 }))

  const selectBrandKit = (brandKitId?: Key) => {
    designStore?.setBrandVisualKitId(parseInt(brandKitId as string))
  }

  return (
    <Section.Root>
      <Section.Header>
        <Text variant="smallList">Brand Colors</Text>
        <MenuTrigger>
          <Button variant="tertiary" size="xs" endIcon={() => <ChevronDown size={16} />}>
            <span className={Styles.brandColorsBrandName}>{brandKit.name}</span>
          </Button>
          <Menu
            selectionMode="single"
            selectedKeys={brandKit ? new Set([brandKit.id.toString()]) : new Set()}
            onAction={selectBrandKit}
          >
            {brandVisualKits.map((brandVisualKit) => (
              <Item key={brandVisualKit.id}>{brandVisualKit.name}</Item>
            ))}
          </Menu>
        </MenuTrigger>
      </Section.Header>

      <div className={Styles.colorsGrid}>
        {colors.map((color, index) => (
          <div key={index} className={Styles.colorGridItem}>
            <ColorSwatch
              color={color}
              isSelected={isEqual(color, selectedColor)}
              onPress={() => onSelect(color)}
              size={isMobile ? 42 : 30}
            />
          </div>
        ))}
      </div>
    </Section.Root>
  )
})
